import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as PublicContentIcon } from '../../../assets/images/PublicContentIcon.svg';
import Header from '../../../components/shared/Header/Header';
import { getUserDetails } from '../../../redux/actions/userActions';
import urls from '../../../routing/urls';
import Profile from '../Profile/Profile';

import styles from './PublicProfile.module.scss';

const PublicProfile = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = useSelector((state) => state.authReducer.currentUser.user?.id);
  const userDetails = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (!userDetails.id) {
      dispatch(getUserDetails(id));
    }
  }, [id]);

  return (
    <div className={styles.container}>
      <Header title={t('headers.myAccount')} />
      <div className={styles.profileCont}>
        <div className={styles.banner}>
          <div className={styles.bannerInfo}>
            <PublicContentIcon />
            <p className={styles.label}>{t('profile.contentIsPublic')}</p>
          </div>
          <div>
            <p
              className={`${styles.label} ${styles.backLink}`}
              onClick={() => navigate(urls.profile)}
              role="presentation"
            >
              {t('profile.exitViewAs')}
            </p>
          </div>
        </div>
        <Profile isPublic />
      </div>
    </div>
  );
};

export default PublicProfile;
